import { Services } from '@/infra/services';
import { type Response as CartShipmentsResponse } from '@/infra/services/checkout/cart/get-cart-shipments';

export interface GetCartShipmentsProps {
  cartId: string;
}

export async function getCartShipments(
  props: Readonly<GetCartShipmentsProps>
): Promise<CartShipmentsResponse> {
  const { cartId } = props;

  return await Services.Checkout.Cart.getCartShipments({
    cartId,
    zip_code: '20540-103', // TODO: precisa recuperar o CEP aqui
  });
}
